import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export function triggerGoal() {
  window.dispatchEvent(new CustomEvent('vt-goal'));
}

export default function GoalAnimation() {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const handler = () => {
      setActive(true);
      setTimeout(() => setActive(false), 2200);
    };
    window.addEventListener('vt-goal', handler);
    return () => window.removeEventListener('vt-goal', handler);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-[100] overflow-hidden">
      <AnimatePresence>
        {active && (
          <>
            {/* Goal net */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="absolute bottom-0 right-10 md:right-20"
              style={{ width: '320px', height: '200px' }}
            >
              <svg viewBox="0 0 320 200" className="w-full h-full" style={{ filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.3))' }}>
                {/* Net pattern */}
                <defs>
                  <pattern id="goalnet" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                    <path d="M 0 0 L 20 0 M 0 0 L 0 20 M 0 0 L 20 20" stroke="white" strokeWidth="0.8" fill="none" opacity="0.5" />
                  </pattern>
                </defs>
                {/* Posts */}
                <rect x="0" y="0" width="8" height="200" fill="white" rx="2" />
                <rect x="312" y="0" width="8" height="200" fill="white" rx="2" />
                <rect x="0" y="0" width="320" height="6" fill="white" rx="2" />
                {/* Net */}
                <path d="M 8 6 L 312 6 L 312 200 L 8 200 Z" fill="url(#goalnet)" />
              </svg>
            </motion.div>

            {/* Ball */}
            <motion.div
              initial={{ x: -200, y: 200, rotate: 0, scale: 0.8 }}
              animate={{ x: 650, y: 50, rotate: 720, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1.0, ease: [0.25, 0.1, 0.25, 1] }}
              className="absolute bottom-24 left-10 md:left-20"
            >
              <svg width="48" height="48" viewBox="0 0 48 48">
                <circle cx="24" cy="24" r="22" fill="white" stroke="black" strokeWidth="1.5" />
                <polygon points="24,14 30,18 28,26 20,26 18,18" fill="black" />
                <polygon points="24,4 30,8 28,14 20,14 18,8" fill="none" stroke="black" strokeWidth="1" />
                <polygon points="44,24 40,30 34,28 34,20 40,18" fill="none" stroke="black" strokeWidth="1" />
                <polygon points="4,24 8,30 14,28 14,20 8,18" fill="none" stroke="black" strokeWidth="1" />
                <polygon points="24,44 30,40 28,34 20,34 18,40" fill="none" stroke="black" strokeWidth="1" />
              </svg>
            </motion.div>

            {/* GOAL text */}
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ delay: 0.8, duration: 0.3 }}
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            >
              <span className="font-heading text-6xl md:text-8xl text-primary drop-shadow-lg tracking-wider">MARK!</span>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
}